<template>
  <vx-card class="no-body-padding" :subtitle="$t('checkup_information.cadence.title')" v-if="assignmentResource">
    <vs-row class="py-6">
      <vs-col vs-lg="6" vs-sm="12" class="px-6 py-2">
        <vs-row>
          <vs-col vs-w="4">
            <span>{{ $t('checkup_information.cadence.fields.frequency') }}</span>
          </vs-col>
          <vs-col vs-w="8">
            <vs-select class="w-full"
                        :autocomplete="false"
                        name="frequency"
                        :data-vv-as="$t('checkup_information.cadence.fields.frequency')"
                        v-model="assignment.checkupFrequency"
                        v-validate=""
                        @change="onSelectCheckupFrequency"
                        :danger="errors.has('frequency')"
                        :danger-text="errors.first('frequency')">
              <vs-select-item v-for="(frequency, idxFrequency) in checkupFrequencyOptions" :key="idxFrequency" :value="frequency.value" :text="frequency.text"></vs-select-item>
            </vs-select>
          </vs-col>
        </vs-row>
      </vs-col>

      <vs-col vs-lg="6" vs-sm="12" class="px-6 py-2">
        <vs-row>
          <vs-col vs-w="4">
            <span>{{ $t('checkup_information.cadence.fields.amount') }}</span>
          </vs-col>
          <vs-col vs-w="8">
            <vs-select class="w-full"
                        :autocomplete="false"
                        name="amount"
                        :data-vv-as="$t('checkup_information.cadence.fields.amount')"
                        v-model="assignment.checkupQuantityDue"
                        v-validate=""
                        @change="onSelectcheckupQuantityDue"
                        :danger="errors.has('amount')"
                        :danger-text="errors.first('amount')">
              <vs-select-item v-for="(amount, idxAmount) in checkupAmountOptions" :key="idxAmount" :value="amount.value" :text="amount.text"></vs-select-item>
            </vs-select>
          </vs-col>
        </vs-row>
      </vs-col>

      <vs-col vs-lg="6" vs-sm="12" class="px-6 py-2"></vs-col>

      <vs-col vs-lg="6" vs-sm="12" class="px-6 py-2">
        <vs-row>
          <vs-col vs-w="4">
            <span>{{ $t('checkup_information.cadence.fields.completed') }}</span>
          </vs-col>
          <vs-col vs-w="8">
            <vs-input class="w-full"
                        name="completed"
                        readonly
                        :value="$t('checkup_information.cadence.completed_options.qty_checkups', { qty: assignment.checkupQuantityCompleted || 0 })">
            </vs-input>
          </vs-col>
        </vs-row>
      </vs-col>

      <vs-col vs-w="12" class="px-6 text-center" v-if="isFormDirty">
        <vs-button @click="submit" color="secondary" size="small">
            {{ $t('checkup_information.cadence.button_send') }}
        </vs-button>
      </vs-col>
    </vs-row>
  </vx-card>
</template>

<script>
import { ResourceImpl } from 'hal-client';

export default {
  name: 'checkup-cadence',
  props: {
    memberResource: {
      type: ResourceImpl
    }
  },
  data () {
    return {
      loading: false,
      assignmentResource: null,
      assignment: {
        checkupFrequency: null,
        checkupQuantityDue: null,
        checkupQuantityCompleted: null
      },
      checkupFrequencyOptions: [
        { value: null, text: this.$t('checkup_information.cadence.frequency_options.member_discretion') },
        { value: 1, text: this.$t('checkup_information.cadence.frequency_options.every_week') },
        { value: 2, text: this.$t('checkup_information.cadence.frequency_options.two_weeks') },
        { value: 3, text: this.$t('checkup_information.cadence.frequency_options.three_weeks') },
        { value: 4, text: this.$t('checkup_information.cadence.frequency_options.four_weeks') }
      ],
      checkupAmountOptions: [
        { value: null, text: this.$t('checkup_information.cadence.amount_options.member_discretion') },
        { value: 2, text: this.$t('checkup_information.cadence.amount_options.qty_checkups', { qty: 2 }) },
        { value: 3, text: this.$t('checkup_information.cadence.amount_options.qty_checkups', { qty: 3 }) },
        { value: 4, text: this.$t('checkup_information.cadence.amount_options.qty_checkups', { qty: 4 }) },
        { value: 5, text: this.$t('checkup_information.cadence.amount_options.qty_checkups', { qty: 5 }) },
        { value: 6, text: this.$t('checkup_information.cadence.amount_options.qty_checkups', { qty: 6 }) },
        { value: 7, text: this.$t('checkup_information.cadence.amount_options.qty_checkups', { qty: 7 }) }
      ]
    };
  },
  computed: {
    isFormDirty () {
      return Object.values(this.fields).some(value => value && value.dirty);
    }
  },
  mounted () {
    this.memberResource.$request().$get('checkup-cadence').then(res => {
      this.assignmentResource = res;
      this.assignment = res.state();
    });
  },
  methods: {
    reset () {
      this.assignment = this.assignmentResource.state();
      this.$validator.reset();
    },
    submit () {
      this.$validator.validate().then(valid => {
        if (!valid) return;

        this.loading = true;

        this.assignmentResource.$request().$post('update', null, this.assignment).then(res => {
          this.assignmentResource = res;
          this.reset();

          this.$vs.notify({
            title: 'Assignment Sent',
            text: 'The Check-Up Cadence for the member has been correctly assigned.',
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          });
        }, () => {
          this.$vs.notify({
            time: 5000,
            title: 'An error occured',
            text: 'The Check-Up Cadence for the member has not been correctly assigned. Please try again or contact members@starlingminds.com if the error persists.',
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'danger'
          });
        }).finally(() => {
          this.loading = false;
        });
      });
    },
    onSelectCheckupFrequency (value) {
      this.assignment.checkupQuantityCompleted = 0;
      if (!value) {
        this.assignment.checkupQuantityDue = null;
      } else if (!this.assignment.checkupQuantityDue) {
        this.assignment.checkupQuantityDue = 2;
      }
    },
    onSelectcheckupQuantityDue (value) {
      this.assignment.checkupQuantityCompleted = 0;
      if (!value) {
        this.assignment.checkupFrequency = null;
      } else if (!this.assignment.checkupFrequency) {
        this.assignment.checkupFrequency = 1;
      }
    }
  }
};
</script>
